import React from "react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { Reveal } from "@/components/common/Reveal";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQ } from "@/content/homeContent";

export const Faq = () => {
  return (
    <Section id="faq-section" tone="offwhite">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionHeading microLabel={FAQ.microLabel} title={FAQ.title} />
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.06}>
            <Accordion type="single" collapsible className="w-full">
              {FAQ.items.slice(0, 6).map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-strato-gray-100"
                >
                  <AccordionTrigger className="text-left font-display text-lg font-medium text-strato-graphite hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-[1.65] text-muted-foreground">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </Section>
  );
};
